import $ from 'jquery';
import * as Sentry from '@sentry/browser';
import { init as initApm } from '@elastic/apm-rum';
import { loadNunitoFontFallback } from 'common/utils/loadNunitoFontFallback';

const IGNORED_ERRORS = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'Non-Error promise rejection captured',
  'TypeError: Failed to fetch',
  'TypeError: NetworkError when attempting to fetch resource',
  'You are not authorized to perform this action',
  'You need to sign in or create an account before continuing',
];

const initializeApm = () => {
  if ($('#apm').data('report')) {
    const apmOptions = {
      serviceName: $('#apm').data('service-name'),
      serverUrl: $('#apm').data('server-url'),
      environment: $('#apm').data('apm-environment'),
      active: Math.random() < $('#apm').data('sample-rate'),
    };

    initApm(apmOptions);
  }
};

const initializeSentry = () => {
  // if env is not defined we have a timing issue but since this should only be called on document.ready we should be
  // fine since env gets initialized in the _global_data partial and not from a js file.
  if (!window.env || window.env.STELLA_ENV === 'development' || window.env.STELLA_ENV === 'test')
    return;

  Sentry.init({
    dsn: 'https://e8983a0443a6452687bb0f11d92c8d40@sentry.io/1852866',
    environment: window.env.STELLA_ENV_ID,
    release: window.env.GIT_SHA,
    sampleRate: 0.5,
    ignoreErrors: IGNORED_ERRORS.map(err => new RegExp(err, 'i')),
  });

  Sentry.setTag('company', document.location.host.split('.')[0]);

  const userInfo = document.querySelector('#user-details');
  if (!userInfo) return;

  Sentry.setUser({
    email: userInfo.dataset.email,
    role: userInfo.dataset.userRole,
  });
};

$(document).ready(() => {
  loadNunitoFontFallback();
  initializeSentry();
  initializeApm();

  // Some of these legacy libs are required across all application
  // This is why these three libraries are initialized here and in application.jsx
  // And to avoid double initialization we need some flag
  // TODO: regroup common libs
  if (!window.__legacyLibsInited) {
    // Legacy header dropdown
    require('legacy/libs/bootstrap/dropdown'); // dropdown fixed on line 80 to not interfer with custom-ui
    require('legacy/javascripts/custom-ui');
    // Legacy bootstrap switch
    require('legacy/libs/bootstrap-switch');
    window.__legacyLibsInited = true;
  }
});
